export const Loading = () => {
  return (
    <div className="text-center bg-gray-800 min-h-[90vh] flex flex-col items-center justify-center">
      <div className="inline h-16 w-16 animate-[spin_4s_linear_infinite]">
        <svg
          className="inline h-16 w-16 animate-pulse"
          version="1.1"
          id="Capa_1"
          x="0px"
          y="0px"
          viewBox="0 0 58.036 58.036"
        >
          <g>
            <path
              className="fill-gray-200"
              /*   style="fill:#EFEFEF;" */
              d="M17.714,48.614l28.504,6.148c1.256,0.271,2.494-0.528,2.765-1.784l9-41.725
		c0.271-1.256-0.528-2.494-1.784-2.765L27.696,2.341c-1.256-0.271-2.494,0.528-2.765,1.784l-9,41.725
		C15.66,47.105,16.458,48.343,17.714,48.614z"
            />
            <path
              className="fill-gray-400"
              /*    style="fill:#E0E2E0;" */
              d="M17.714,48.614c-1.256-0.271-2.055-1.509-1.784-2.765l8.374-38.824L8.497,4.837
		C7.225,4.661,6.05,5.55,5.874,6.823L0.022,49.104c-0.176,1.273,0.713,2.448,1.986,2.624l28.884,3.997
		c1.273,0.176,2.447-0.713,2.624-1.986l0.231-1.667L17.714,48.614z"
            />
            <path
              className="fill-red-700"
              /*  style="fill:#C03A2B;" */
              d="M34.58,39.569c-5.01-5.322-7.21-9.804-8.012-12.992c-0.937-3.726,1.591-8.277,5.361-9.017
		c4.431-0.87,6.691,3.28,6.691,3.28s3.77-2.849,7.448-0.23c3.129,2.229,3.557,7.417,1.167,10.425
		C45.191,33.609,41.339,36.786,34.58,39.569z"
            />
            <path
              className="fill-gray-900"
              /*   style="fill:#2C2F38;" */
              d="M22.218,16.701c-0.334-0.323-0.678-0.647-1.037-0.976c-6.531,3.281-10.134,6.737-11.981,9.458
		c-2.157,3.179-1.343,8.321,1.944,10.309c3.25,1.966,6.267,0.072,7.146-0.58L22.218,16.701z"
            />
          </g>
        </svg>
      </div>
    </div>
  );
};
